/**
 * WhatsApp message builder for Majlis Mart. No emojis, RTL aware, correct shop name.
 * (Previously used window.Shopify.shop, which is the myshopify.com domain - the greeting read "Hello xxx.myshopify.com".)
 */
(function () {
  'use strict';

  const shopLabel = () => (window.theme && window.theme.shopName) || 'Majlis Mart';

  window.WhatsAppEngine = {
    cleanPhoneNumber(phone) {
      const cleaned = String(phone || '').replace(/[^0-9]/g, '');
      return cleaned || '971569819317';
    },

    formatMoney(cents) {
      return window.MM ? window.MM.formatMoney(cents) : (cents / 100).toFixed(2) + ' AED';
    },

    buildProductMessage({ shopName = shopLabel(), productTitle = '', variantTitle = '', quantity = 1, price = 0, url = '', isRTL = false }) {
      const money = this.formatMoney(price);
      const hasVariant = variantTitle && variantTitle.toLowerCase() !== 'default title';
      const lines = isRTL
        ? ['مرحباً ' + shopName + '، أود طلب التالي:', '', '• المنتج: ' + productTitle]
        : ['Hello ' + shopName + ', I would like to order:', '', '• Product: ' + productTitle];
      if (hasVariant) lines.push((isRTL ? '• الخيار: ' : '• Variant: ') + variantTitle);
      lines.push((isRTL ? '• الكمية: ' : '• Quantity: ') + quantity);
      lines.push((isRTL ? '• السعر: ' : '• Price: ') + money);
      if (url) lines.push((isRTL ? '• رابط المنتج: ' : '• Product Link: ') + url);
      lines.push('', isRTL ? 'يرجى تأكيد التوفر وتفاصيل التوصيل داخل الإمارات. شكراً!' : 'Please confirm availability and UAE delivery details. Thank you!');
      return lines.join('\n');
    },

    buildCartMessage({ shopName = shopLabel(), items = [], totalPrice = 0, isRTL = false }) {
      const lines = [isRTL ? 'مرحباً ' + shopName + '، أود طلب محتويات السلة:' : 'Hello ' + shopName + ', I would like to order my cart:', ''];
      items.forEach((item, i) => {
        lines.push((i + 1) + '. ' + (item.product_title || item.title));
        if (item.variant_title && item.variant_title.toLowerCase() !== 'default title') lines.push((isRTL ? '   - الخيار: ' : '   - Variant: ') + item.variant_title);
        lines.push((isRTL ? '   - الكمية: ' : '   - Qty: ') + item.quantity + ' (' + (isRTL ? 'سعر الوحدة: ' : 'Unit: ') + this.formatMoney(item.final_price != null ? item.final_price : item.price) + ')');
      });
      lines.push('', (isRTL ? 'المجموع: ' : 'Total: ') + this.formatMoney(totalPrice));
      lines.push(isRTL ? 'يرجى تأكيد الطلب وموعد التوصيل داخل الإمارات.' : 'Please confirm my order and UAE delivery schedule.');
      return lines.join('\n');
    },

    createWhatsAppUrl(phone, text) {
      return 'https://wa.me/' + this.cleanPhoneNumber(phone) + '?text=' + encodeURIComponent(text);
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    const isRTL = document.documentElement.dir === 'rtl';

    function updateProductButton() {
      const btn = document.querySelector('[data-whatsapp-button]');
      if (!btn) return;
      const qtyInput = document.querySelector('[data-qty-input]');
      const message = window.WhatsAppEngine.buildProductMessage({
        productTitle: btn.dataset.productTitle || '',
        variantTitle: btn.dataset.variantTitle || '',
        quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1,
        price: parseInt(btn.dataset.variantPrice || '0', 10),
        url: btn.dataset.productUrl || window.location.href,
        isRTL
      });
      const href = window.WhatsAppEngine.createWhatsAppUrl(btn.dataset.phone || (window.theme && window.theme.settings.whatsappNumber), message);
      btn.href = href;
      const sticky = document.querySelector('[data-sticky-whatsapp-btn]');
      if (sticky) sticky.href = href;
    }

    document.addEventListener('input', (e) => { if (e.target && e.target.matches('[data-qty-input]')) updateProductButton(); });
    document.addEventListener('variant:change', (e) => {
      const btn = document.querySelector('[data-whatsapp-button]');
      if (btn && e.detail && e.detail.variant) {
        btn.dataset.variantId = e.detail.variant.id;
        btn.dataset.variantTitle = e.detail.variant.title;
        btn.dataset.variantPrice = e.detail.variant.price;
        updateProductButton();
      }
    });

    document.addEventListener('click', async (e) => {
      const cartBtn = e.target.closest('[data-cart-whatsapp-order]');
      if (!cartBtn) return;
      e.preventDefault();
      try {
        const root = (window.MM && window.MM.root) || '/';
        const cart = await (await fetch(root + 'cart.js')).json();
        const message = window.WhatsAppEngine.buildCartMessage({ shopName: cartBtn.dataset.shopName || shopLabel(), items: cart.items || [], totalPrice: cart.total_price || 0, isRTL });
        window.open(window.WhatsAppEngine.createWhatsAppUrl(cartBtn.dataset.phone || (window.theme && window.theme.settings.whatsappNumber), message), '_blank', 'noopener,noreferrer');
      } catch (err) {
        console.error('WhatsApp cart order failed', err);
      }
    });

    updateProductButton();
  });
})();